
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 450 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0072C6","d":"M0 0h450v300H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M0 0h450v200H0z"}}),_c('path',{attrs:{"fill":"#1EB53A","d":"M0 0h450v100H0z"}})])
          )
        }
      }
    